// extracted by mini-css-extract-plugin
export var card = "_sy-0";
export var details = "_sy-1";